import type { JumpToPageProps } from './types/jump-to-page.props';

import { useJumpToPageConfiguration } from './hooks/jump-to-page-configuration.hook';

import cssClasses from './jump-to-page.module.css';

export const JumpToPage = ({ disabled = false, onPageChange }: JumpToPageProps) => {
  const { handleOnChange, inputId, ref, totalPages } = useJumpToPageConfiguration({ onPageChange });

  return (
    <div className={cssClasses.jumpToPage}>
      <label
        className="flex items-center"
        htmlFor={inputId}>
        Jump to page:
      </label>
      <input
        aria-label="Jump to page number"
        className={cssClasses.input}
        disabled={disabled}
        id={inputId}
        max={totalPages}
        min={1}
        onChange={({ target: { value } }) => {
          handleOnChange(value);
        }}
        placeholder="#"
        ref={ref}
        type="number"
      />
    </div>
  );
};
